export function parseMaxSize(size: string | number | undefined): number | undefined {
  if (size === undefined) return undefined
  if (typeof size === 'number') return size
  const match = size.match(/^(\d+(?:\.\d+)?)\s*(b|kb|mb|gb)/i)
  if (!match) return undefined
  const value = parseFloat(match[1])
  const units: Record<string, number> = { b: 1, kb: 1024, mb: 1024 ** 2, gb: 1024 ** 3 }
  return value * units[match[2].toLowerCase()]
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 ** 2) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1024 ** 3) return `${(bytes / 1024 ** 2).toFixed(1)} MB`
  return `${(bytes / 1024 ** 3).toFixed(1)} GB`
}
